// extracted by mini-css-extract-plugin
module.exports = {"NoData":"InviteeList_NoData__OcVjs"};